import {
  AppConnectBeamErrorCode,
  AppConnectChillPayErrorCode,
  AppConnectExceptionCode,
  LoadingStatusType,
  TypeComponentNoti,
} from "@/enums/enums";
import {
  BeamRequestModel,
  ChillPayRequestModel,
  DataBeamPaymentModel,
  DataChillPayPaymentModel,
  DataPaySolutionPaymentModel,
  DataQRPaymentModel,
  GetTransactionRemainPaymentModel,
  PaySolutionRequestModel,
  QRCodePaymentModel,
} from "@/model/payment/paymentModel";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Payment extends VuexModule {
  private transactionRemainPaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private transactionRemainPaymentModel: any = null;
  private isConfirmPayment: boolean = false;
  private scbQRCodePaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private scbQRCodePaymentModel: DataQRPaymentModel | null = null;
  private bayQRCodePaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private bayQRCodePaymentModel: DataQRPaymentModel | null = null;
  private bblQRCodePaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private bblQRCodePaymentModel: DataQRPaymentModel | null = null;
  private paySolutionPaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private paySolutionPaymentModel: DataPaySolutionPaymentModel | null = null;
  private beamPaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private beamPaymentModel: DataBeamPaymentModel | null = null;
  private chillPayPaymentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private chillPayPaymentModel: DataChillPayPaymentModel | null = null;

  get getTransactionRemainPaymentLoadingStatus(): LoadingStatusType {
    return this.transactionRemainPaymentLoadingStatus;
  }
  get getTransactionRemainPaymentModel(): any {
    return this.transactionRemainPaymentModel;
  }
  get getIsConfirmPayment(): boolean {
    return this.isConfirmPayment;
  }
  get getSCBQRCodePaymentLoadingStatus(): LoadingStatusType {
    return this.scbQRCodePaymentLoadingStatus;
  }
  get getSCBQRCodePaymentModel(): DataQRPaymentModel | null {
    return this.scbQRCodePaymentModel;
  }
  get getBayQRCodePaymentLoadingStatus(): LoadingStatusType {
    return this.bayQRCodePaymentLoadingStatus;
  }
  get getBayQRCodePaymentModel(): DataQRPaymentModel | null {
    return this.bayQRCodePaymentModel;
  }
  get getBblQRCodePaymentLoadingStatus(): LoadingStatusType {
    return this.bblQRCodePaymentLoadingStatus;
  }
  get getBblQRCodePaymentModel(): DataQRPaymentModel | null {
    return this.bayQRCodePaymentModel;
  }
  get getPaySolutionPaymentLoadingStatus(): LoadingStatusType {
    return this.paySolutionPaymentLoadingStatus;
  }
  get getBeamPaymentLoadingStatus(): LoadingStatusType {
    return this.beamPaymentLoadingStatus;
  }
  get getChillPayPaymentLoadingStatus(): LoadingStatusType {
    return this.chillPayPaymentLoadingStatus;
  }
  get getPaySolutionPaymentModel(): DataPaySolutionPaymentModel | null {
    return this.paySolutionPaymentModel;
  }
  get getBeamPaymentModel(): DataBeamPaymentModel | null {
    return this.beamPaymentModel;
  }
  get getChillPayPaymentModel(): DataChillPayPaymentModel | null {
    return this.chillPayPaymentModel;
  }

  @Mutation
  public MutationTransactionRemainPaymentLoadingStatus(status: LoadingStatusType) {
    this.transactionRemainPaymentLoadingStatus = status;
  }
  @Mutation
  public MutationSetTransactionRemainPaymentModel(transactionRemainPaymentModel: any) {
    this.transactionRemainPaymentModel = transactionRemainPaymentModel;
  }
  @Mutation
  public MutationSetIsConfirmPayment(isConfirmPayment: boolean) {
    this.isConfirmPayment = isConfirmPayment;
  }
  @Mutation
  public MutationSCBQRCodePaymentLoadingStatus(status: LoadingStatusType) {
    this.scbQRCodePaymentLoadingStatus = status;
  }
  @Mutation
  public MutationSCBQRCodePaymentModel(qrPaymentModel: DataQRPaymentModel) {
    this.scbQRCodePaymentModel = qrPaymentModel;
  }
  @Mutation
  public MutationBayQRCodePaymentLoadingStatus(status: LoadingStatusType) {
    this.bayQRCodePaymentLoadingStatus = status;
  }
  @Mutation
  public MutationBayQRCodePaymentModel(qrPaymentModel: DataQRPaymentModel) {
    this.bayQRCodePaymentModel = qrPaymentModel;
  }
  @Mutation
  public MutationBblQRCodePaymentLoadingStatus(status: LoadingStatusType) {
    this.bblQRCodePaymentLoadingStatus = status;
  }
  @Mutation
  public MutationBblQRCodePaymentModel(qrPaymentModel: DataQRPaymentModel) {
    this.bayQRCodePaymentModel = qrPaymentModel;
  }
  @Mutation
  public MutationPaySolutionPaymentLoadingStatus(status: LoadingStatusType) {
    this.paySolutionPaymentLoadingStatus = status;
  }
  @Mutation
  public MutationBeamPaymentLoadingStatus(status: LoadingStatusType) {
    this.beamPaymentLoadingStatus = status;
  }
  @Mutation
  public MutationChillPayPaymentLoadingStatus(status: LoadingStatusType) {
    this.chillPayPaymentLoadingStatus = status;
  }
  @Mutation
  public MutationPaySolutionPaymentModel(paySolutionPaymentModel: DataPaySolutionPaymentModel) {
    this.paySolutionPaymentModel = paySolutionPaymentModel;
  }
  @Mutation
  public MutationBeamPaymentModel(beamPaymentModel: DataBeamPaymentModel) {
    this.beamPaymentModel = beamPaymentModel;
  }
  @Mutation
  public MutationChillPayPaymentModel(chillPayPaymentModel: DataBeamPaymentModel) {
    this.chillPayPaymentModel = chillPayPaymentModel;
  }

  @Action
  public DoGetTransactionRemainPayment(input: GetTransactionRemainPaymentModel) {
    if (this.transactionRemainPaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationTransactionRemainPaymentLoadingStatus", LoadingStatusType.Loading);
      this.context.commit("MutationSetIsConfirmPayment", input.isConfirmPayment);
      API.PaymentService.DoGetTransactionRemainPayment(input).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetTransactionRemainPaymentModel", res.data.data);
          this.context.commit("MutationTransactionRemainPaymentLoadingStatus", LoadingStatusType.Success);
        } else {
          this.context.commit("MutationTransactionRemainPaymentLoadingStatus", LoadingStatusType.None);
        }
      });
    }
  }
  @Action
  public DoGetSCBQRCodePayment(input: QRCodePaymentModel) {
    if (this.scbQRCodePaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSCBQRCodePaymentLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetSCBQRCodePayment(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationSCBQRCodePaymentModel", res.data.data);
        }
        this.context.commit("MutationSCBQRCodePaymentLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetBayQRCodePayment(input: QRCodePaymentModel) {
    if (this.bayQRCodePaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationBayQRCodePaymentLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetBayQRCodePayment(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationBayQRCodePaymentModel", res.data.data);
        }
        this.context.commit("MutationBayQRCodePaymentLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetBblQRCodePayment(input: QRCodePaymentModel) {
    if (this.bblQRCodePaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationBblQRCodePaymentLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetBblQRCodePayment(input).then((res: any) => {
        if (res.status.IsSuccess()) {
          this.context.commit("MutationBblQRCodePaymentModel", res.data.data);
        }
        this.context.commit("MutationBblQRCodePaymentLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetPaySolutionPayment(input: PaySolutionRequestModel) {
    if (this.paySolutionPaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationPaySolutionPaymentLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetPaySolutionPayment(input).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationPaySolutionPaymentModel", res.data.data);
          this.context.commit("MutationPaySolutionPaymentLoadingStatus", LoadingStatusType.Success);
        } else {
          this.context.commit("MutationPaySolutionPaymentLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetBeamPayment(input: BeamRequestModel) {
    if (this.beamPaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationBeamPaymentLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetBeamPayment(input).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationBeamPaymentModel", res.data.data);
          this.context.commit("MutationBeamPaymentLoadingStatus", LoadingStatusType.Success);
        } else {
          if (
            res.data.exception.exceptionCode == AppConnectExceptionCode.Beam &&
            res.data.exception.errorCode == AppConnectBeamErrorCode.NotHavePayableAmount
          ) {
            this.context.commit("MutationTransactionRemainPaymentLoadingStatus", LoadingStatusType.None);
          }
          this.context.commit("MutationBeamPaymentLoadingStatus", LoadingStatusType.Fail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetChillPayPayment(input: ChillPayRequestModel) {
    if (this.chillPayPaymentLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationChillPayPaymentLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.DoGetChillPayPayment(input).then((res: any) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationChillPayPaymentModel", res.data.data);
          this.context.commit("MutationChillPayPaymentLoadingStatus", LoadingStatusType.Success);
        } else {
          let alertMessage = "";
          if (res.data.exception.exceptionCode == AppConnectExceptionCode.ChillPay) {
            if (res.data.exception.errorCode == AppConnectChillPayErrorCode.NotHavePayableAmount) {
              alertMessage = "";
              this.context.commit("MutationTransactionRemainPaymentLoadingStatus", LoadingStatusType.None);
            } else if (res.data.exception.errorCode == AppConnectChillPayErrorCode.PaymentUrlNotFound) {
              alertMessage = "URL Result not set.";
            } else if (res.data.exception.errorCode == AppConnectChillPayErrorCode.DataIsNull) {
              alertMessage = "Setting is not found.";
            }
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
          }
          this.context.commit("MutationChillPayPaymentLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }
}
